export default "__VITE_ASSET__44800972__"